export default __webpack_public_path__ + "static/media/img_rifatul.48d7d793.png";